import { MdDelete } from 'react-icons/md';

export default function IndustryTypeTable({ data, onEdit, onDelete }) {
  return (
   <div className="overflow-x-auto">
  <table className="w-full mt-4 border-separate border-spacing-0">
    <thead className="bg-dark">
      <tr>
        <th className=" text-white border-0">Industry Name</th>
        <th className=" text-white border-0">Actions</th>
      </tr>
    </thead>
    <tbody>
      {data.length === 0 ? (
        <tr>
          <td colSpan={2} className="text-center text-gray-500 p-4">
            No industry types found.
          </td>
        </tr>
      ) : (
        data.map((item, index) => (
          <tr
            key={item.id}
            className={`transition ${
              index % 2 === 1 ? 'bg-[#fddddd]' : ''
            }`}
          >
            <td className="p-3 border-0">{item.industryType}</td>
            <td className="p-3 border-0">
              <div className="flex justify-content-center gap-3">
                {/* <button
                  onClick={() => onEdit(item)}
                  className="text-[#b22222] hover:underline"
                  title="Edit"
                >
                  <FaEdit />
                </button> */}
                <button
                  onClick={() => onDelete(item.id)}
                  className="x-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                  title="Delete"
                >
                   <MdDelete className="text-lg text-red-600" />
                </button>
              </div>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>
  );
}
